import { loginStart, loginSuccess, apiError, logout, registerStart, registerSuccess, loginEnd } from './reducer';
import { postLogin, postLogout, postRegister } from '../../apiCalls/api_calls';
import i18n from '../../i18n';

export const registerUser = (user, navigate, ref) => async (dispatch) => {
  dispatch(registerStart());
  try {
    const res = await postRegister(user);
    if (res) {
      dispatch(registerSuccess());
      navigate('/register-success');
    }
  } catch (error) {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
    dispatch(apiError(error?.message || error));
  }
};

export const loginUser = (credentials, navigate) => async (dispatch) => {
  sessionStorage.removeItem("customer_cart_context");
  dispatch(loginStart());
  try {
    const res = await postLogin(credentials);
    if (res?.data) {
      dispatch(loginSuccess(res.data));
      navigate('/', { replace: true });
    } else {
      dispatch(apiError(i18n.t('auth.loginError')));
    }
  } catch (error) {
    dispatch(apiError(error?.message || error || i18n.t('auth.loginError')));
  } finally {
    dispatch(loginEnd());
  }
};

export const logoutUser = (navigate) => async (dispatch) => {
  try {
    sessionStorage.removeItem("customer_cart_context");
    dispatch(logout());
    if (navigate) {
      navigate('/login');
    }
    await postLogout();
  } catch (error) {
    dispatch(apiError(error?.message || error || i18n.t('auth.logoutError')));
  }
};
